import React from "react";
import { useI18n } from "@/i18n";

export default function TermsConditions() {
  const { t } = useI18n();
  const sections = ["s1","s2","s3","s4","s5","s6","s7","s8"];
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="border-b border-[#e6e0d3] pb-6 mb-8">
          <div className="text-xs uppercase tracking-[0.22em] text-[#B85D3D]">Xyrqelo</div>
          <h1 className="mt-2 font-serif text-3xl md:text-4xl text-[#0F2447]">{t("terms.title")}</h1>
          <p className="mt-2 text-sm text-[#5a6474]">{t("terms.updated")}</p>
        </div>
        <p className="text-base text-[#3d4757] leading-relaxed">{t("terms.intro")}</p>
        <div className="mt-8 space-y-8">
          {sections.map((s) => (
            <div key={s}>
              <h2 className="font-serif text-xl text-[#0F2447]">{t(`terms.${s}_title`)}</h2>
              <p className="mt-2 text-sm md:text-base text-[#3d4757] leading-relaxed">{t(`terms.${s}_body`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
